import { APP as Fetch, TRAIN as Fetch_Train } from '@/api'

// 获取资源预览token
export const getCourseViewToken = (params) =>
  Fetch_Train({
    url: '/teacher-train-service/train/course/resource/view',
    method: 'post',
    params
  })

// 获取资源预览url
export const getCourseViewUrl = (params) =>
  Fetch_Train({
    url: '/file-center/preview/url',
    method: 'post',
    params
  })

// 获取课程详情
export const getCourseDetail = (params, data) => {
  return Fetch_Train({
    url: '/teacher-train-service/train/course/center/details',
    method: 'post',
    params,
    data
  })
}

// 上报视频时长
export const postCourseStudyTime = (data) => {
  return Fetch_Train({
    url: '/weikeanswer-basic/wkans/view/weikeViewSec',
    method: 'post',
    data
  })
}

// 获取视频地址
export const postWeikeVideo = (data) =>
  Fetch({
    url: '/api/weike/url',
    method: 'post',
    data
  }).then((res) => {
    if (res?.data?.m3u8url) {
      // TODO: 目前测试环境和生产环境视频源相同，但测试环境前面多了 test- 导致视频无法观看，现暂时通过前端控制后续还需通过接口层优化
      res.data.m3u8url = res.data.m3u8url.replaceAll('test-', '')
    }
    return res
  })

// 考试报名接口
export const postRegisterExecirse = (params) => {
  return Fetch_Train({
    url: '/teacher-train-service/train/resource/paper/register',
    method: 'post',
    params
  })
}

// 进入考试
export const postEnterExecirse = (data) => {
  return Fetch_Train({
    url: '/qu-answer-basic/quanswer/answer/exam/enter',
    method: 'post',
    data
  })
}

// 获取考试试卷
export const postExecirseList = (params) => {
  return Fetch_Train({
    url: '/qu-answer-basic/quanswer/answer/answerSepPaperData',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    params
  })
}

// 交卷
export const postSubmitExecirse = (data) => {
  return Fetch_Train({
    url: '/qu-answer-basic/quanswer/answer/submit',
    method: 'post',
    data
  })
}

// 保存作答记录
export const postSaveAnswer = (data) => {
  return Fetch_Train({
    url: '/qu-answer-basic/quanswer/answer/saveQuAnsweringRecord',
    method: 'post',
    data
  })
}

// 获取用户作答记录
export const postAnswerScoreResult = (params) => {
  return Fetch_Train({
    url: '/qu-answer-basic/quanswer/ansresult/query/answerScoreResult',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    params
  })
}

// 下载附件
export const getDownloadFile = (params) => {
  return Fetch_Train({
    url: '/file-center/attachment/get/download/url',
    method: 'get',
    params
  })
}
